import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-204" data-mp="3fz5mltnqbceo">
      <div className="mx-auto max-w-6xl" data-id="element-205" data-mp="3fxksu698nxhv">
        <Eyebrow data-id="element-206" data-mp="3b143x9u7tf3q">From people using the system</Eyebrow>
        <SectionTitle data-id="element-207" data-mp="3ayhypgusrboo">
          What people say about having <Mark data-id="element-208" data-mp="36z9469rxn9s2">a clearer exercise system</Mark>
        </SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-3" data-id="element-209" data-mp="32060otrlpbm7">
          {testimonials.map(item => <figure key={item.name} className="flex flex-col rounded-2xl border border-navy/10 bg-canvas p-6" data-id="element-210" data-mp="2x0jnulfopxdx">
              <QuoteIcon className="h-6 w-6 text-brand" aria-hidden="true" data-id="element-211" data-mp="2s28c255txct2" />
              <p className="mt-3 font-display text-sm font-black uppercase leading-snug text-navy" data-id="element-212" data-mp="v9gavpibo6q7">{item.headline}</p>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-steel" data-id="element-213" data-mp="q9tytje8cwiz">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-214" data-mp="h5oqhd9wga8h">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xs font-black text-white" data-id="element-215" data-mp="m5b4vq1grwiv">
                  {item.initials}
                </span>
                <span data-id="element-216" data-mp="c7wpltra1ds5">
                  <span className="block text-sm font-extrabold text-navy" data-id="element-217" data-mp="c7dfgz7vbtoo">{item.name}</span>
                  <span className="block text-xs text-steel" data-id="element-218" data-mp="zwy2pub21d3r">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-steel" data-id="element-219" data-mp="q7eh4gvyj557">Individual experiences may vary.</p>
      </div>
    </section>;
}